import React from 'react';

export default function TimebasedSummaryComp(props){
    return (
        <article className='time-based-summary' style={props.style}>
            <div className='label'>{props.label}</div>

            <div className='value'>
                <strong>{props.number}</strong>
                {props.units}
                <small>
                    {props.timeFramePrefix || 'In Last'} <em>{props.timeFrameText}</em>
                </small>
            </div>
        </article>
    );
}
